module.exports = __webpack_public_path__ + "img/gm.5c1ff6b5.svg";